export const someAreFalsy =
  <O extends Object>(...trackedParams: (keyof O)[]) =>
  (obj: O): boolean => {
    return trackedParams.some(param => !obj[param])
  }

export const includeInKey =
  <O extends Object>(...trackedParams: (keyof O)[]) =>
  (obj: O): string => {
    return trackedParams.map(param => obj[param]).join('-')
  }

export function createMemoizedTransformer<TNativeArgs, TState, TResult>(
  transformer: (nativeArgs: TNativeArgs, state: TState) => TResult
): (nativeArgs: TNativeArgs, state: TState) => TResult {
  let lastResult: TResult
  let initialized = false

  return (nativeArgs: TNativeArgs, state: TState): TResult => {
    const newResult = transformer(nativeArgs, state)

    if (initialized && shallowEqual(newResult, lastResult)) {
      return lastResult
    }

    lastResult = newResult
    initialized = true
    return newResult
  }
}

// A simple shallow equality function.
// It works for primitives or objects with primitive values.
function shallowEqual<T>(objA: T, objB: T): boolean {
  if (objA === objB) return true

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false
  }

  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)

  if (keysA.length !== keysB.length) return false

  for (const key of keysA) {
    if ((objA as Record<string, unknown>)[key] !== (objB as Record<string, unknown>)[key]) {
      return false
    }
  }

  return true
}
